import { Location } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';

import { Chats, Message } from '../shared/chats.model';
import { ChatsService } from '../shared/chats.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {
  @ViewChild('scrollAuto') scrollAuto: ElementRef;
  public asTs;
  public chat: Chats;
  public msg: Message = {} as Message;
  public messages: Message[] = [];
  public inputMessage = '';
  public isShowModal: Boolean = false;
  public contentModal: String;
  public infiniteScroll: Boolean = false;
  public isLoading: Boolean = false;
  private _data: Message[] = [];
  private _dataLength = 0;
  private _subscription: Subscription;

  @Input()
  set chatId(id: string) {
    this.messages = [];
    this.infiniteScroll = false;
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
    this._subscription = this.service.get(id).subscribe((data: Chats) => {
      this.chat = data;
      this._data = data.messages;
      this._dataLength = data.messages.length;
      this._pushDataToMessages(true, this._data, this.messages);
    });
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ChatsService,
    private _location: Location
  ) {}

  ngOnInit() {}
  ngViewDidLoad() {}

  public scrollToBottom() {
    try {
      setTimeout(() => {
        this.scrollAuto.nativeElement.scrollTop = this.scrollAuto.nativeElement.scrollHeight;
      });
    } catch (err) {
      console.log(err);
    }
  }
  private _pushDataToMessages(
    loading: boolean,
    data: Message[],
    messages: Message[]
  ) {
    if (data.length - messages.length > 0) {
      if (this._dataLength > 5) {
        data
          .slice(this._dataLength - 6, this._dataLength)
          .reverse()
          .map(e => {
            messages.unshift(e);
          });
        this._dataLength = this._dataLength - 6;
        this.isLoading = false;
      } else {
        data
          .slice(0, this._dataLength)
          .reverse()
          .map(e => {
            messages.unshift(e);
          });
        this.isLoading = false;
      }
      if (loading) {
        this.scrollToBottom();
      } else {
        setTimeout(() => {
          this.scrollAuto.nativeElement.scrollTop = 50;
        });
      }
    } else {
      this.isLoading = false;
      this.infiniteScroll = true;
    }
  }

  public goBack = () => this._location.back();

  public changeListener(e): void {
    this._readFiles(e.target);
  }

  private _readFiles(inputValue: any) {
    const file: File = inputValue.files[length];
    const myReader: FileReader = new FileReader();
    myReader.onloadend = e => {
      this.snapshotResize(myReader.result);
    };
    myReader.readAsDataURL(file);
  }

  snapshotResize(base64) {
    // Max size for thumbnail
    const maxWidth = 500;
    const maxHeight = 500;

    // Create and initialize two canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const canvasCopy = document.createElement('canvas');
    const copyContext = canvasCopy.getContext('2d');

    // Create original image
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      // Determine new ratio based on max size
      let ratio = 1;
      if (img.width > maxWidth) {
        ratio = maxWidth / img.width;
      } else if (img.height > maxHeight) {
        ratio = maxHeight / img.height;
      }

      // Draw original image in second canvas
      canvasCopy.width = img.width;
      canvasCopy.height = img.height;
      copyContext.drawImage(img, 0, 0);

      // Copy and resize second canvas to first canvas
      canvas.width = img.width * ratio;
      canvas.height = img.height * ratio;
      ctx.drawImage(
        canvasCopy,
        0,
        0,
        canvasCopy.width,
        canvasCopy.height,
        0,
        0,
        canvas.width,
        canvas.height
      );
      canvas.toDataURL();
      const body = {
        content: canvas.toDataURL('image/jpeg'),
        _type: 'image',
        by: 'admin'
      };
      this._sendMessage(body);
    };
  }

  addMessage() {
    if (this.inputMessage) {
      const body = {
        content: this.inputMessage,
        _type: 'text',
        by: 'admin'
      };
      this._sendMessage(body);
    } else {
      this.isShowModal = true;
      this.contentModal = 'Vui lòng nhập tin nhắn.';
    }
  }
  private _sendMessage(msg: any) {
    this.inputMessage = '';
    this.service.createMessage(this.chat._id, 'messages', msg).subscribe(
      (message: Message) => {
        this.messages.push(message);
        setTimeout(() => {
          this.scrollToBottom();
        });
      },
      e => {
        this.isShowModal = true;
        this.contentModal =
          'Không thể gửi tin vào lúc này, vui lòng thử lại sau';
      }
    );
  }
  scrolledUp(e) {
    if (e.currentScrollPosition === 0) {
      this.isLoading = true;
      setTimeout(() => {
        this._pushDataToMessages(false, this._data, this.messages);
      }, 600);
    }
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/chats/chat/chat.component.ts